(function () {
  if (window.__cmHeroAuto) return;
  window.__cmHeroAuto = true;
  var reduced = window.matchMedia('(prefers-reduced-motion:reduce)');

  function bind(root) {
    if (root.dataset.autoBound) return;
    var slides = Array.prototype.slice.call(root.querySelectorAll('[data-cm-slide]'));
    var next = root.querySelector('[data-cm-slide-step="1"]');
    var prev = root.querySelector('[data-cm-slide-step="-1"]');
    if (slides.length < 2 || !next || !prev) return;
    root.dataset.autoBound = 'true';

    var imgMs = Number(root.dataset.cmAutoplay) || 0;
    var vidMs = Number(root.dataset.cmAutoplayVideo) || imgMs;
    var design = !!(window.Shopify && window.Shopify.designMode);
    var timer = 0, inView = true, focused = false, last = 0;

    function current() {
      for (var i = 0; i < slides.length; i++) if (!slides[i].hidden) return i;
      return 0;
    }
    function plan() {
      clearTimeout(timer);
      if (!imgMs || design || reduced.matches || document.hidden || !inView || focused || !root.isConnected) return;
      var video = slides[current()].hasAttribute('data-cm-video-hero');
      timer = setTimeout(function () { go(next); }, video ? vidMs : imgMs);
    }
    function go(button) {
      root.classList.add('is-fx');
      button.click();
      plan();
    }

    document.addEventListener('cm:hero-slide', function () {
      if (!root.isConnected) return;
      var i = current();
      if (i !== last && slides[i].hasAttribute('data-cm-video-hero')) {
        var v = slides[i].querySelector('video');
        if (v) { try { v.currentTime = 0; } catch (e) {} }
      }
      last = i;
      plan();
    });
    document.addEventListener('visibilitychange', plan);
    if (reduced.addEventListener) reduced.addEventListener('change', plan);

    root.addEventListener('focusin', function (e) {
      try { focused = e.target.matches(':focus-visible'); } catch (x) { focused = false; }
      plan();
    });
    root.addEventListener('focusout', function () { focused = false; plan(); });

    var sx = 0, sy = 0, tracking = false;
    root.addEventListener('touchstart', function (e) {
      if (e.touches.length !== 1) { tracking = false; return; }
      tracking = true;
      sx = e.touches[0].clientX;
      sy = e.touches[0].clientY;
    }, { passive: true });
    root.addEventListener('touchend', function (e) {
      if (!tracking) return;
      tracking = false;
      var t = e.changedTouches[0];
      var dx = t.clientX - sx, dy = t.clientY - sy;
      if (Math.abs(dx) > 50 && Math.abs(dx) > Math.abs(dy) * 1.5) go(dx < 0 ? next : prev);
    }, { passive: true });

    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        inView = entries[entries.length - 1].isIntersecting;
        plan();
      }, { threshold: 0.2 }).observe(root);
    }
    plan();
  }

  function init() {
    document.querySelectorAll('[data-cm-hero-slider]').forEach(bind);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', init);
})();